<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OddD6U/tc-custom/9780062046253.jpg?1733089179547" alt="This image is the cover for the book Life Worth Living"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life Worth Living
      </h1>
      <p class="bookDescription body article font2">
        <p>Inspirational and heartwarming, <i>A Life Worth Living</i> provides a insightful guide to living life meaningfully and well. In a time when everyday life is dominated by the pursuit of material wealth, Dr. Barrie Sanford Greiff has redefined "net worth" as a life not dominated by the financial bottom line. Weaving together memorable stories and insights gathered during his long tenure as a Harvard psychiatrist, Greiff highlights in this though-provoking book nine essentials that make true worth: Loving, Learning, Laboring, Laughing, Lamenting, Linking, Living, Leading and Leaving. By heightening our awareness of these essentials in our lives, he reasons, we can find the path to spiritual worth -- and learn that sharing life lessons is the best way to make our lives worthwhile. Both pragmatic and uplifting,<i> A Life Worth Living</i> offers an inspiring remedy for the spiritual myopia of our time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barrie Sanford Greiff
      </h2>
      
      <p class="authorDescription body article">&#160; Barrie Sanford Greiff, M.D. is a psychiatric consultant to the Harvard University Heath Services. He has consulted for a wide range of organizations from Fortune 500 Companies to privately helf family business. For almost two decades he was the pychiatrist to the Harvard Business School, where he pioneered a unique course dealing with the juggling of self, family, and work life. He has lectured nationally and conducts a consulting practice in Cambridge, Massachusetts</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38d90c45